<template>
<div class="row">
    <div class="col-12">
        <div class="form-group col-sm-3">
            <label>Zgjedh Afatin</label>
            <select class="custom-select" v-model="selected" @change="onChange($event)">
                <option v-for="item in afati" :key="item.id" :value='item.afatiID'> {{item.afati}}</option>
            </select>
        </div>
        <card>
            <div slot="raw-content" class="table-responsive">
                <div class="text-uppercase text-bold">Orari i provimeve:</div>
                <table class="table table-striped table-hover">
                    <div class="text-center" v-if="loader">
                        <div class="spinner-border" role="status">
                            <span class="visually-hidden"></span>
                        </div>
                    </div>
                    <thead>
                        <tr>
                            <th>L&#235;nda</th>
                            <th>Ligj&#235;ruesi</th>
                            <th>Data</th>
                            <th>Dita</th>
                            <th>Ora</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="i in tabela" :key="i.afatiID">
                            <td>{{i.lenda}}</td>
                            <td>{{ i.profesori }}</td>
                            <td>{{ i.data_e_provimit}}</td>
                            <td style="text-transform:capitalize;">{{ i.dita}}</td>
                            <td>{{ i.ora_provimit}}</td>

                        </tr>
                    </tbody>
                </table>
            </div>
        </card>

        <!-- Provimet e paraqitura -->
    </div>
</div>
</template>

<script>

import { APISettings } from '../api/config.js'

export default {
    data() {
        return {
            items: [],
            selected: [],
            selectAll: false,
            afati: [],
            tabela: [],
            test: 0,
            loader: false,
        };
    },
    methods: {
        select() {
            this.selected = [];
            if (!this.selectAll) {
                for (let i in this.items) {
                    this.selected.push(this.items[i].lenda);
                }
            }
        },
        getOrari() {
            var get_token = this.$cookies.get("accesstoken");

            fetch(APISettings.baseURL + `Afatet/getAfati/`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + get_token
                    },
                })
                .then(
                    (signinResponse) => {
                        signinResponse.json().then((res) => {
                            if (signinResponse.status === 200) {
                                res.forEach(obj => {
                                    this.afati.push(obj);
                                   
                                });

                            } else if (signinResponse.status === 400) {
                                console.log("ERROR DATA1");
                            }
                        })
                    }).catch(error => {
                    console.log("ERROR DATA2");
                })
        },

        onChange(event) {
            this.test = event.target.value;
            this.getTabela();
        },

        getTabela() {
            var get_token = this.$cookies.get("accesstoken");
            fetch(APISettings.baseURL + `Afatet/getOrari_Provimev/${this.test}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + get_token
                    },
                })
                .then(
                    (signinResponse) => {
                        signinResponse.json().then((res) => {
                            if (signinResponse.status === 200) {
                                this.tabela = [];
                                res.forEach(obj => {
                                    this.tabela.push(obj);
                                    window.location.reload;
                                });
                            } else if (signinResponse.status === 400) {
                                console.log("ERROR DATA1");
                            }
                        })
                    }).catch(error => {
                    console.log("ERROR DATA2");
                })
        },
    },
    beforeMount() {
        this.getOrari();
    },
};
</script>

<style>

</style>
